import './rangeSlider.scss'

const RangeSlider = (props) => {
  const percentage = 100 * (props.value - props.min) / (props.max - props.min)

  const rangerStyle = {
    background: `linear-gradient(90deg, var(--tabActive) 0, var(--tabActive) ${percentage}%, ${props.secondaryBgColor ? props.secondaryBgColor : 'rgba(215, 220, 223, 0.4)'} ${percentage + 0.1}%)`, borderColor: `var(--tabActive)`
  }

  return (
    <input className={`range-slider-input ${props.value === 0 ? 'min-value' : 'max-value'} ${props.customClasses ? props.customClasses : ''}`} style={rangerStyle} type='range' value={props.value} min={props.min} max={props.max} onChange={props.onChange} disabled={props.disabled} />
  )
}

export default RangeSlider
